/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'confluence-fast-and-snappy-survey': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-fast-and-snappy-survey/placements/in-app/screen-space-flags/render'
			),
	),
	'confluence-lovability-survey': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--confluence-lovability-survey/placements/in-app/screen-space-flags/render'
			),
	),
};
